import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/notifications").then(r => setRows(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const resolve = async (id) => {
    await api.post(`/notifications/${id}/resolve`);
    toast.success("Marked as resolved");
    load();
  };

  const open = rows.filter(r => r.status === "open");
  const resolved = rows.filter(r => r.status === "resolved");

  return (
    <div className="px-4 md:px-8 py-8 max-w-4xl mx-auto w-full">
      <div className="flex items-center gap-3 mb-2">
        <Bell size={22} weight="duotone" />
        <h1 className="font-heading text-4xl">Missing-info alerts</h1>
      </div>
      <p className="text-ink-soft mb-6">
        Questions Tracey couldn't answer. Add matching documentation to the knowledge base, then mark the alert as resolved.
      </p>

      {loading ? (
        <div className="text-ink-soft">Loading…</div>
      ) : (
        <>
          <Section title={`Open (${open.length})`} rows={open} onResolve={resolve} />
          <Section title={`Resolved (${resolved.length})`} rows={resolved} muted />
        </>
      )}
    </div>
  );
}

function Section({ title, rows, onResolve, muted }) {
  if (!rows.length) return null;
  return (
    <div className="mb-8">
      <div className="text-[11px] uppercase tracking-widest text-ink-soft mb-2">{title}</div>
      <ul className="border border-line rounded-2xl bg-surface/40 divide-y divide-line overflow-hidden" data-testid="notif-list">
        {rows.map((n) => (
          <li key={n.id} className={`p-4 flex flex-col md:flex-row md:items-center gap-3 ${muted ? "opacity-70" : ""}`}>
            <div className="flex-1 min-w-0">
              <div className="font-medium">"{n.question}"</div>
              <div className="text-xs text-ink-soft mt-1">
                Asked by <span className="font-medium">{n.asked_by_name}</span> · {new Date(n.created_at).toLocaleString()}
              </div>
              {n.manager_emails?.length > 0 && (
                <div className="text-[11px] text-ink-soft mt-1">Notified: {n.manager_emails.join(", ")}</div>
              )}
            </div>
            {onResolve && (
              <Button variant="outline" onClick={()=>onResolve(n.id)} data-testid={`resolve-${n.id}`}
                className="rounded-full whitespace-nowrap">
                <CheckCircle size={14} weight="duotone" className="mr-1.5" /> Mark resolved
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
